import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared/shared.module';
import {NotificationIndicatorComponent} from './notification-indicator.component';

@NgModule({
    declarations: [
        NotificationIndicatorComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        NotificationIndicatorComponent
    ]
})
export class SharedNotificationIndicatorModule {
}
